import Section from '@pelckmans/elementis/components/section';
import List from '@pelckmans/elementis/components/list';
import Pill from '@pelckmans/elementis/components/pill';
import { useTranslation } from 'react-i18next';
import { isScorableMedialink, Medialink } from '../../../../../api/medialink';
import MedialinkListItem from '../MedialinkListItem';
import { ANALYTICS_EVENT_SUBLOCATIONS } from '../../../../../constants/analyticsEvents';

interface Props {
  medialinks: Medialink[];
  getMedialinksForExerciseCategory: () => Promise<void>;
}

function SharedMedialinksSection({ medialinks, getMedialinksForExerciseCategory }: Props) {
  const { t } = useTranslation();

  if (medialinks.length === 0) {
    return null;
  }

  return (
    <Section title={t('PAGES.VEM.MATERIAL_SECTION.SHARED_MATERIALS.TITLE')}>
      <List>
        {medialinks.map(m => (
          <MedialinkListItem
            key={m.id}
            medialink={m}
            onCloseCallback={getMedialinksForExerciseCategory}
            scorable={isScorableMedialink(m)}
            pills={<Pill key="content-type-pill">{m.contentType.name}</Pill>}
            subLocationId={ANALYTICS_EVENT_SUBLOCATIONS.PORTAAL_VIRTUAL_EXERCISE_MODULE_SHARED_MATERIAL}
          />
        ))}
      </List>
    </Section>
  );
}

export default SharedMedialinksSection;
